<app-ptrab-two-factor-card
  actionsPosition="between"
  title="LOGIN.VERIFY_NUMBER"
  imageSrc="assets/imgs/ptrab/seleccionar_telefono.svg"
  [buttons]="buttons()">
  <div class="phone-selection-card__container">
    <span class="phone-selection-card__text">
      @if (isSinglePhone()) {
        {{ 'TWO_FACTOR.VERIFY_NUMBER.INFO.ONE_PHONE.HEADER' | mTranslate }}
        {{
          'TWO_FACTOR.VERIFY_NUMBER.INFO.ONE_PHONE.ONE_PHONE' | mTranslate: { value1: uniquePhone()?.phone | slice: -3 }
        }}
      } @else {
        {{ 'TWO_FACTOR.VERIFY_NUMBER.INFO.INFO' | mTranslate }}
      }
    </span>

    @if (!isSinglePhone()) {
      <m-radio-group
        alignment="vertical"
        size="small"
        [value]="selectedPhoneId()"
        (valueChange)="setSelectedPhone($event)">
        @for (phone of availablePhones(); track phone.id) {
          <m-radio-button [value]="phone.id">{{ phone.phone }}</m-radio-button>
        }
      </m-radio-group>
    }

    <span class="phone-selection-card__text">{{ reminderMessage | mTranslate }}</span>
  </div>
</app-ptrab-two-factor-card>
